import { createTheme } from '@mui/material';
/**
 * Custom theme to remove the ripple from ButtonBase.
 */
export const NoRippleTheme = createTheme({
    components: {
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true,
            },
        },
    },
});
/**
 * Custom theme to add the Gilroy font to the MUI theme.
 */
export const fontTheme = createTheme({
    typography: {
        fontFamily: 'Gilroy, Verdana, sans-serif',
    },
});
